import { db } from "../firebase/config";
import { collection, doc, addDoc, updateDoc, deleteDoc, onSnapshot } from "firebase/firestore";

// Listen to all customers in real-time
export function subscribeToCustomers(callback) {
  return onSnapshot(collection(db, "customers"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    // Sort alphabetically by name
    list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to customers:", error);
    callback([], error);
  });
}

// Ensure default customers are seeded if the collection is empty
export async function seedDefaultCustomersIfEmpty(customers) {
  if (customers.length > 0) return;

  const mockCustomers = [
    { 
      name: "Nexus Enterprises Inc.", 
      category: "Enterprise", 
      status: "Active", 
      address: "100 Innovation Way",
      city: "New York",
      state: "NY",
      zip: "10001",
      pocs: [{ name: "John Connor", title: "VP of Procurement", email: "jconnor@nexus.com", phone: "555-0199" }]
    },
    { 
      name: "Summit Retailers Group", 
      category: "Retailer", 
      status: "Active", 
      address: "789 Mountain Heights",
      city: "Denver",
      state: "CO",
      zip: "80202",
      pocs: [{ name: "Sarah Miller", title: "Purchasing Agent", email: "smiller@summitretail.com", phone: "555-0218" }]
    },
    { 
      name: "Nova Solutions LLC", 
      category: "Enterprise", 
      status: "Active", 
      address: "456 Silicon Hills Blvd",
      city: "Austin",
      state: "TX",
      zip: "78701",
      pocs: [{ name: "Alex Vance", title: "Sourcing Specialist", email: "avance@novasol.com", phone: "555-0391" }]
    },
    { 
      name: "Apex Department of Defense", 
      category: "Government", 
      status: "Active", 
      address: "1200 Pentagon Mall",
      city: "Washington",
      state: "DC",
      zip: "20301",
      pocs: [{ name: "Gen. James Becker", title: "Logistics Command", email: "jbecker@dod.gov", phone: "555-0482" }]
    },
    { 
      name: "Quantum Wholesale", 
      category: "Wholesaler", 
      status: "Inactive", 
      address: "88 Logistics Center",
      city: "Atlanta",
      state: "GA",
      zip: "30301",
      pocs: [{ name: "David Chen", title: "Supply Chain Manager", email: "dchen@quantum.com", phone: "555-0555" }]
    }
  ];

  for (const item of mockCustomers) {
    try {
      await addDoc(collection(db, "customers"), item);
    } catch (e) {
      console.error("Failed to seed customer:", e);
    }
  }
}

// Add a new customer
export async function addCustomer(customerData) {
  const docRef = await addDoc(collection(db, "customers"), customerData);
  return docRef.id;
}

// Update an existing customer
export async function updateCustomer(id, customerData) {
  const docRef = doc(db, "customers", id);
  await updateDoc(docRef, customerData);
}

// Delete a customer
export async function deleteCustomer(id) {
  const docRef = doc(db, "customers", id);
  await deleteDoc(docRef);
}

// Listen to customer categories
export function subscribeToCustomerCategories(callback) {
  return onSnapshot(collection(db, "customer_categories"), (snapshot) => {
    let list = [];
    snapshot.forEach((doc) => {
      list.push(doc.data().name);
    });
    if (list.length === 0) {
      callback(["Enterprise", "Retailer", "Distributor", "Wholesaler", "Government", "Other"]);
    } else {
      list.sort((a, b) => a.localeCompare(b));
      callback(list);
    }
  }, (error) => {
    console.error("Error subscribing to customer categories:", error);
    callback([], error);
  });
}

// Listen to customer payment methods (used in Procurement Estimates and CRM Customers)
export function subscribeToPaymentMethods(callback) {
  return onSnapshot(collection(db, "payment_methods"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to payment methods:", error);
    callback([], error);
  });
}

// Listen to internal payment methods (used in Purchase)
export function subscribeToInternalPaymentMethods(callback) {
  return onSnapshot(collection(db, "internal_payment_methods"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to internal payment methods:", error);
    callback([], error);
  });
}
